import { SchoolYear } from "@/entities/schoolYear/schoolYear"
import { addDays, endOfDay, startOfDay } from "date-fns"
import { useMemo } from "react"

interface Period {
   start_date: Date
   end_date: Date
}

export function findAllSchoolPeriods(schoolYear: SchoolYear): Period[] {
   if (!schoolYear.vacation_periods.length) {
      return [
         {
            start_date: schoolYear.start_date,
            end_date: schoolYear.end_date,
         },
      ]
   }

   const sortedVacations = [...schoolYear.vacation_periods].sort(
      (a, b) => a.start_date.getTime() - b.start_date.getTime(),
   )

   const periods: Period[] = []

   // First period before first vacation
   periods.push({
      start_date: schoolYear.start_date,
      end_date: endOfDay(addDays(sortedVacations[0].start_date, -1)),
   })

   // Periods between vacations
   for (let i = 0; i < sortedVacations.length - 1; i++) {
      periods.push({
         start_date: startOfDay(addDays(sortedVacations[i].end_date, 1)),
         end_date: endOfDay(addDays(sortedVacations[i + 1].start_date, -1)),
      })
   }

   // Last period after last vacation
   periods.push({
      start_date: startOfDay(addDays(sortedVacations[sortedVacations.length - 1].end_date, 1)),
      end_date: schoolYear.end_date,
   })

   return periods
}

export function useAllSchoolPeriods(schoolYear?: SchoolYear): Period[] {
   return useMemo(() => (!schoolYear ? [] : findAllSchoolPeriods(schoolYear)), [schoolYear])
}
